<template>
  <div
    class="d-flex flex-row add-position p-2 ml-0"
    :class="{ 'border-informacion-lf': btnNuevo }"
    v-if="!loadingCargos"
  >
    <div class="col-6 m-0 p-2">
      <b-form-group class="" label="Cargo">
        <vue-bootstrap-typeahead
          ref="vueBootstrapTypeahead"
          inputClass="redondo-8 form-control form-control-lg"
          v-model="$v.position_sub_scenario.position.name.$model"
          :data="cargos"
          :serializer="(item) => item.name"
          @hit="cargoSeleccionado = $event"
          placeholder="Buscar..."
        >
        </vue-bootstrap-typeahead>
        <b-form-invalid-feedback
          :state="
            !$v.position_sub_scenario.position.name.$dirty
              ? null
              : $v.position_sub_scenario.position.name.required
          "
        >
          <span class="icon icon-info"></span> Obligatorio
        </b-form-invalid-feedback>
      </b-form-group>
    </div>

    <div class="col-4 m-0 p-2">
      <b-form-group class="" label="Puntaje">
        <b-form-input
          class="redondo-8"
          size="lg"
          placeholder="Puntaje"
          v-model="$v.position_sub_scenario.points.$model"
          type="number"
          :state="
            !this.$v.position_sub_scenario.points.$dirty
              ? null
              : !this.$v.position_sub_scenario.points.$error
              ? null
              : !this.$v.position_sub_scenario.points.$error
          "
        ></b-form-input>
        <b-form-invalid-feedback
          :state="
            !$v.position_sub_scenario.points.$dirty
              ? null
              : $v.position_sub_scenario.points.required
          "
        >
          <span class="icon icon-info"></span> Obligatorio
        </b-form-invalid-feedback>
      </b-form-group>
    </div>

    <div class="col-2 m-0 p-2 pl-0">
      <b-button
        class="align-middle add-btn mt-5 ml-4"
        pill
        size="lg"
        v-if="btnNuevo"
        v-b-tooltip.hover
        title="Agregar"
        @click="agregar"
        >+</b-button
      >
      <b-button
        class="align-middle delete mt-5 ml-4"
        pill
        size="lg"
        v-b-tooltip.hover
        title="Eliminar"
        v-if="btnEditar"
        @click="eliminar(index)"
        >X</b-button
      >
    </div>
  </div>
</template>

<script>
const { required } = require("vuelidate/lib/validators");
import { mapActions, mapState } from "vuex";
export default {
  name: "add-position",
  data() {
    return {
      cargoSeleccionado: null,
    };
  },
  watch: {
    cargoSeleccionado: function (event) {
      this.position_sub_scenario.pro_position_id = event.id;
      this.position_sub_scenario.position = event;
    },
  },
  props: {
    index: {
      default: null,
      type: Number,
    },
    indexSubScenario: {
      default: null,
      type: Number,
    },
    btnNuevo: {
      default: true,
      type: Boolean,
    },
    btnEditar: {
      default: false,
      type: Boolean,
    },
    puntos: {
      default: null,
      type: Number,
    },
    position_id: {
      default: null,
      type: Number,
    },
    sub_scenario: {
      default: null,
      type: Object,
    },
    position_sub_scenario: {
      type: Object,
      default() {
        return {
          id: null,
          pro_position_id: null,
          pro_subscenario_id: null,
          points: null,
          position: {
            id: null,
            name: null,
            category_type: null,
            pro_category_id: null,
            pro_section_id: null,
            training: null,
            core_role_id: null,
          },
        };
      },
    },
  },
  validations: {
    position_sub_scenario: {
      points: {
        required,
      },
      position: {
        name: {
          required,
        },
      },
    },
  },
  beforeMount() {},
  mounted() {
    // Se llena el campo del autocomplete manualmente por que el campo no tiene
    // un valor por defecto.
    this.$refs.vueBootstrapTypeahead.inputValue =
      typeof this.position_sub_scenario.position.name === "string"
        ? this.position_sub_scenario.position.name
        : "";
  },
  computed: {
    ...mapState("modScenarios", ["loadingCargos", "cargos"]),
  },
  methods: {
    ...mapActions("modScenarios", ["actSetPostion"]),
    agregar() {
      this.$v.position_sub_scenario.$touch();
      if (this.$v.position_sub_scenario.$invalid) {
        return false;
      }
      this.position_sub_scenario.indexSubScenario = this.indexSubScenario;
      this.actSetPostion(Object.assign({}, this.position_sub_scenario));
      this.limpiar();
    },

    limpiar() {
      this.setSubScenarioPosition();
      this.$v.position_sub_scenario.$reset();
      this.$refs.vueBootstrapTypeahead.inputValue = "";
      this.$emit("agregar", this.position_sub_scenario);
    },

    eliminar(index) {
      // Crear ventana para validar la eliminación del cargo.
      let cargo = this.cargos.find(
        (item) => item.id === this.position_sub_scenario.position.id
      );
      this.$bvModal
        .msgBoxConfirm(
          "Nombre: " +
            cargo.name +
            " Puntos: " +
            this.position_sub_scenario.points,
          {
            title: "¿Está seguro de eliminar este cargo?",
            buttonSize: "lg",
            okVariant: "danger",
            okTitle: "Si",
            cancelTitle: "No",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.sub_scenario.position_sub_scenario.splice(index, 1);
            this.$emit("eliminar", index);
          }
        });
    },

    setSubScenarioPosition() {
      this.position_sub_scenario.pro_position_id = null;
      this.position_sub_scenario.points = null;
      this.position_sub_scenario.position = {
        id: null,
        name: null,
        category_type: null,
        pro_category_id: null,
        pro_section_id: null,
        training: null,
        core_role_id: null,
      };
    },
  },
};
</script>

<style>
.add-position {
  min-height: 50px;
  overflow-y: 50px;
}
</style>